export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-24 pb-20">
      {/* Animated Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-black via-gray-900 to-black"></div>
        <div className="absolute inset-0 opacity-30">
          {[...Array(50)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-yellow-500 rounded-full animate-pulse"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${2 + Math.random() * 3}s`
              }}
            ></div>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <img 
            src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/b4573abb41861ee3e1a13dce7bef25dc.jpeg" 
            alt="Smart Hizmet Logo" 
            className="h-20 w-auto object-contain"
          />
        </div>

        {/* Badges */}
        <div className="flex flex-wrap items-center justify-center gap-3 mb-8">
          <span className="px-5 py-2.5 bg-green-600/20 border border-green-500 text-green-400 rounded-full text-sm font-bold backdrop-blur-sm shadow-lg shadow-green-500/20">
            ✓ 1 Ay Ücretsiz Deneme
          </span>
          <span className="px-5 py-2.5 bg-red-600/20 border border-red-500 text-red-400 rounded-full text-sm font-bold backdrop-blur-sm shadow-lg shadow-red-500/20">
            ✓ Önce Kazan Sonra Öde
          </span>
          <span className="px-5 py-2.5 bg-yellow-600/20 border border-yellow-500 text-yellow-400 rounded-full text-sm font-bold backdrop-blur-sm shadow-lg shadow-yellow-500/20">
            ✓ Türkiye'de İlk ve Tek Sistem
          </span>
        </div>

        {/* Main Headline */}
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
          <span className="bg-gradient-to-r from-white via-yellow-200 to-yellow-500 bg-clip-text text-transparent">
            Mesaj Değil
          </span>
          <br />
          <span className="text-white">Müşteri Sağlıyoruz</span>
        </h1>

        {/* Subheadline */}
        <p className="text-lg sm:text-xl lg:text-2xl text-gray-300 max-w-4xl mx-auto mb-12 leading-relaxed">
          Türkiye'de ilk defa geliştirilen Yapay Zeka + Reklam + Müşteri Yönetimi sistemi ile işletmelere sürekli müşteri kazandırıyoruz.
        </p>

        {/* Hero Visual */}
        <div className="relative max-w-5xl mx-auto">
          <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/20 to-blue-500/20 blur-3xl"></div>
          <img 
            src="https://readdy.ai/api/search-image?query=futuristic%20AI%20assistant%20hologram%20with%20glowing%20gold%20energy%20particles%2C%20digital%20marketing%20technology%20interface%2C%20premium%20business%20dashboard%20with%20data%20visualization%2C%20dark%20background%20with%20blue%20and%20gold%20accent%20lights%2C%20high-tech%20startup%20product%20design%2C%20modern%20minimalist%20style%2C%20professional%20corporate%20aesthetic%2C%20floating%20UI%20elements%2C%20sophisticated%20technology%20platform&width=1200&height=600&seq=hero-smart-hizmet-001&orientation=landscape" 
            alt="Smart Hizmet AI System" 
            className="relative rounded-2xl shadow-2xl shadow-yellow-500/20 w-full h-auto object-cover"
          />
        </div>
      </div>
    </section>
  );
}